import { render } from "./WorkStationTable.vue?vue&type=template&id=5bfa7e38&scoped=true"
import script from "./WorkStationTable.vue?vue&type=script&lang=js"
export * from "./WorkStationTable.vue?vue&type=script&lang=js"

import "./WorkStationTable.vue?vue&type=style&index=0&id=5bfa7e38&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfa7e38"]])

export default __exports__